import { render, staticRenderFns } from "./ProjectLanguageDropdown.vue?vue&type=template&id=828fe6b0"
import script from "./ProjectLanguageDropdown.vue?vue&type=script&lang=js"
export * from "./ProjectLanguageDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports